import React, { Fragment, useEffect, useState } from 'react';
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap';
import "./DocumentType.css";
import { useDispatch, useSelector } from 'react-redux';
import { getDocumentTypeList, updateDocumentType } from '../../../api/workflow';
import CustomPagination from '../../../components/Pagination/CustomPagination';
import Loader from '../../../components/Loader/Loader';
import { failed, success } from '../../../utils/Tostify';
import { useConfirmDialog } from '../../../hooks/useConfirmDialog';
import { decryptData } from '../../../utils/helper';
import moment from 'moment';
import EditDocumentType from './EditDocumentType';

function DocumentTypeList({ searchValue, direction, ...args }) {
    let token = useSelector(state => state.userReducer.token);
    const [dropdownOpen, setDropdownOpen] = useState([]);
    const [documentList, setDocumentList] = useState([]);
    const [docData, setdocData] = useState({});
    const [showModal, setShowModal] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const { getConfirmation } = useConfirmDialog();
    const dispatch  = useDispatch();
    const toggleDropdown = (id) => {
      setDropdownOpen(prevState => prevState.includes(id) ? prevState.filter(item => item !== id) : [...prevState, id]);
    };

    const getDocumentList = async (page, limit, searchKey = "") => {
        let res;
        try {
            setIsLoading(true);
            // setSearch(searchKey);
            res = await getDocumentTypeList({dispatch, token, page, limit, searchKey});
            const responseData = decryptData(res?.data);
            if (res?.status === "SUCCESS") {
                setDocumentList(responseData);
                setIsLoading(false);
            }else{
              setIsLoading(false);
              failed(res?.message);
            }
        } catch (error) {
            failed(res?.message);
            setIsLoading(false);
        }
      };
      const handlePagination = (page) => {
        getDocumentList(page, 10);
      };
      const handlePublished = async (e, docId) => {
        const isChecked = e.target.checked;
        e.target.checked = !isChecked;
        const msg = isChecked ? "Publish" : "Unpublish";
        const confirmed = await getConfirmation({
            title: "Attention!",
            entryName: "",
            actionBtnTitle: "Yes",
            message: `Are you sure you want to ${msg}?`
        });
        if (confirmed) {
            let res;
            try {
                const values = {isPublished: isChecked};
                setIsLoading(true);
                res = await updateDocumentType({values, dispatch, token, docId});
                if (res?.status === "SUCCESS") {
                    await getDocumentList(documentList?.currentPage, 10);
                    setIsLoading(false);
                    success(res?.message);
                } else {
                    setIsLoading(false);
                    failed(res?.message);
                }
            } catch (error) {
                setIsLoading(false);
                failed(res?.message);
            }
        } else {
            e.target.checked = !isChecked;
        }
      };
      const handleDelete = async(docName, docId)=>{
        const isActive = documentList?.items?.find((obj)=> obj?._id == docId)?.isPublished;
        if(isActive){
            failed("You can't delete an Published Document Type");
            return;
        }
        const confirmed = await getConfirmation({
            title: "Attention!",
            entryName: "",
            actionBtnTitle: "Yes",
            message: `Are you sure you want to Delete ${docName}?`
        });
        if (confirmed) {
            let res;
            try {
                const values = {isDeleted: true};
                setIsLoading(true);
                res = await updateDocumentType({values, dispatch, token, docId});
                if (res?.status === "SUCCESS") {
                    await getDocumentList(documentList?.currentPage, 10);
                    setIsLoading(false);
                    success(res?.message);
                } else {
                    setIsLoading(false);
                    failed(res?.message);
                }
            } catch (error) {
                setIsLoading(false);
                failed(res?.message);
            }
        }
      };
      useEffect(() => {
        getDocumentList(1, 10);
      }, []);
      useEffect(() => {
        let timerOut = setTimeout(async () => {
            getDocumentList(1, 10, searchValue);
        }, 1000);
        return () => clearTimeout(timerOut);
    }, [searchValue]);

    return (
        <Fragment>
            {isLoading && <Loader/>}
            {showModal ? <EditDocumentType refetch={()=> getDocumentList(documentList?.currentPage, 10)} setShowModal={()=> setShowModal(!showModal)} docData={docData}/> : null}
            <div className="table_space table_listing_color">
                <div className="forms_block_workflow">
                    <div className="table-responsive">
                        <table>
                            <thead>
                                <tr className="header_table">
                                    <th>Required Document</th>
                                    <th>Updated</th>
                                    <th>Publish</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                           {documentList?.items?.length > 0  ? documentList?.items.map((doc,index)=>(
                            <tbody key={""}>
                                <tr>
                                    <td colSpan={8} className="bg_light"></td>
                                </tr>
                                <tr className={index % 2 === 0 ? 'first_block' : 'second_block'}>
                                    <td>{doc?.documentTitle}</td>
                                    <td>{moment(doc?.updatedAt).format("MMM-DD-YYYY")}</td>
                                    <td>
                                        <div className="toggle">
                                            <input
                                                type="checkbox"
                                                id={`checktoggle-${doc._id}`}
                                                onChange={(e) => handlePublished(e, doc?._id)}
                                                checked={doc?.isPublished}
                                            />
                                            <label htmlFor={`checktoggle-${doc._id}`}></label>
                                        </div>
                                    </td>
                                    <td>
                                    <Dropdown  className="dropdown_blk" isOpen={dropdownOpen.includes(doc?._id)} toggle={() => toggleDropdown(doc._id)}  direction={direction}>
                                        <DropdownToggle caret size="xl" className="column_blk">
                                            <div className="for_details">
                                            <i className="fa fa-ellipsis-v"></i>
                                            </div>
                                        </DropdownToggle>
                                        <DropdownMenu {...args}>
                                            <DropdownItem className="d-flex gap-2 drop_block_content align-items-center" onClick={()=> {setShowModal(true); setdocData(doc);}}>
                                                <div className="add_hosp">Edit</div>
                                            </DropdownItem>
                                            <DropdownItem className="d-flex gap-2 drop_block_content align-items-center" onClick={()=> {setShowModal(true); setdocData({...doc, readOnly:true});}}>
                                                <div className="add_hosp">View Details</div>
                                            </DropdownItem>
                                            <DropdownItem className="d-flex gap-2 drop_block_content align-items-center" onClick={()=> handleDelete(doc?.documentTitle, doc?._id)}>
                                                <div className="add_hosp" >Delete</div>
                                            </DropdownItem>
                                        </DropdownMenu>
                                    </Dropdown>
                                </td>
                                </tr>
                            </tbody>
                           )) :  <tr><td colSpan={10}><p className="text-center">No Data Found</p></td></tr> }
                        </table>
                    </div>
                    <CustomPagination
                        tableData={documentList?.items}
                        totalPages={documentList?.totalPages}
                        totalRows={documentList?.totalItems}
                        rowsPerPage={10}
                        page={documentList?.currentPage}
                        handlePage={handlePagination}
                    />
                </div>
            </div>
        </Fragment>
    );
}

export default DocumentTypeList;
